import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout'; 
import Home from './Pages/Home'; 
import Page from './Pages/Page';  
import AllVideoCategories from './Pages/AllVideoCategories'; 
import Video from './Pages/Video'; 
import FreeAds from './Pages/FreeAds';    
import Blood from './Pages/Blood';     
import SubCategory from './Pages/Listing/SubCategory';   
import SubSubCategory from './Pages/Listing/SubSubCategory';   
import Listing from './Pages/Listing/Listing';
import ListingDetails from './Pages/Listing/ListingDetails';  
import UserLogin from './Pages/User/Login';
import UserForgotPassword from './Pages/User/ForgotPassword';  
import UserRegister from './Pages/User/Register'; 
import UserHome from './Pages/User/Home'; 
import UserProfile from './Pages/User/Profile';
import UserContactUs from './Pages/User/ContactUs';
import UserReview from './Pages/User/Review';
import UserVideo from './Pages/User/Video';
import UserHelp from './Pages/User/Help';  
import UserVideoPost from './Pages/User/VideoPost';   
import ClientLogin from './Pages/Client/Login';
import ClientForgotPassword from './Pages/Client/ForgotPassword';
import ClientRegister from './Pages/Client/Register';  
import ClientHome from './Pages/Client/Home';    
import ClientProfile from './Pages/Client/Profile';
import ClientContactUs from './Pages/Client/ContactUs';
import ClientMarketFeedback from './Pages/Client/MarketFeedback'; 
import ClientVideo from './Pages/Client/Video';
import ClientHelp from './Pages/Client/Help';  
import ClientListing from './Pages/Client/Listing';  
import ClientListingCreate from './Pages/Client/ListingCreate';   
import ClientListingPaymentStatus from './Pages/Client/ListingPaymentStatus';       
import ClientListingImage from './Pages/Client/ListingImage';    
import ClientListingUpdate from './Pages/Client/ListingUpdate';    
import ClientListingEnquiry from './Pages/Client/ListingEnquiry';
import ClientAds from './Pages/Client/Ads';  
import ClientAdsCreate from './Pages/Client/AdsCreate';     
import ClientAdsPaymentStatus from './Pages/Client/AdsPaymentStatus';  
import ClientAdsUpgrade from './Pages/Client/AdsUpgrade';    
import ClientPayment from './Pages/Client/Payment';
import ClientInvoice from './Pages/Client/Invoice';  
import ClientVideoPost from './Pages/Client/VideoPost';   
import AgentLogin from './Pages/Agent/Login';
import AgentForgotPassword from './Pages/Agent/ForgotPassword';
import AgentRegister from './Pages/Agent/Register';     
import AgentHome from './Pages/Agent/Home'; 
import AgentProfile from './Pages/Agent/Profile';  
import AgentBankAccount from './Pages/Agent/BankAccount';
import AgentWallet from './Pages/Agent/Wallet';  
import AgentContactUs from './Pages/Agent/ContactUs'; 
import AgentVideo from './Pages/Agent/Video';
import AgentHelp from './Pages/Agent/Help';  
import AgentClient from './Pages/Agent/Client';     
import AgentBusiness from './Pages/Agent/Business';
import AgentPayout from './Pages/Agent/Payout';          
import AgentPaymentStatus from './Pages/Agent/PaymentStatus';   
import AgentPayment from './Pages/Agent/Payment'; 
import AgentInvoice from './Pages/Agent/Invoice';   
import AgentIDCard from './Pages/Agent/IDCard'; 
import AgentVideoPost from './Pages/Agent/VideoPost';   
import AgentUser from './Pages/Agent/User'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './App.css';
import { ToastContainer } from 'react-toastify';
import { jwtDecode } from 'jwt-decode'; 
   
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const expirationTime = decodedToken.exp * 1000;
        const currentTime = Date.now();
        if (currentTime >= expirationTime) {
          setIsAuthenticated(false);
          ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        setIsAuthenticated(false);
        ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
      }
    } else {
      setIsAuthenticated(false);
      ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
    }
  }, []);
  return ( 
    <BrowserRouter>  
      <ToastContainer position="bottom-right" />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/:slug" element={<Page />} /> 
          <Route path="/video-categories" element={<AllVideoCategories />} /> 
          <Route path="/video/:slug" element={<Video />} />  
          <Route path="/free-ads" element={<FreeAds />} /> 
          <Route path="/blood" element={<Blood />} />  
          <Route path="/listing/:slug" element={<SubCategory />} />     
          <Route path="/listing/:c_slug/:sc_slug" element={<SubSubCategory />} />    
          <Route path="/listing/:c_slug/:sc_slug/:ssc_slug" element={<Listing />} />    
          <Route path="/listing-details/:u_id" element={<ListingDetails />} /> 
          <Route path="/user/login" element={isAuthenticated ? <Navigate to="/user/home" /> : <UserLogin />} />
          <Route path="/user/forgot-password" element={isAuthenticated ? <Navigate to="/user/profile" /> : <UserForgotPassword />} />  
          <Route path="/user/register" element={isAuthenticated ? <Navigate to="/user/profile" /> : <UserRegister />} />
          <Route path="/user/home" element={isAuthenticated ? <UserHome /> : <Navigate to="/user/login" />} /> 
          <Route path="/user/profile" element={isAuthenticated ? <UserProfile /> : <Navigate to="/user/login" />} />
          <Route path="/user/contact-us" element={isAuthenticated ? <UserContactUs /> : <Navigate to="/user/login" />} />
          <Route path="/user/review" element={isAuthenticated ? <UserReview /> : <Navigate to="/user/login" />} />
          <Route path="/user/video" element={isAuthenticated ? <UserVideo /> : <Navigate to="/user/login" />} />
          <Route path="/user/help" element={isAuthenticated ? <UserHelp /> : <Navigate to="/user/login" />} /> 
          <Route path="/user/video-post" element={isAuthenticated ? <UserVideoPost /> : <Navigate to="/user/login" />} />  
          <Route path="/client/login" element={isAuthenticated ? <Navigate to="/client/home" /> : <ClientLogin />} />
          <Route path="/client/forgot-password" element={isAuthenticated ? <Navigate to="/client/profile" /> : <ClientForgotPassword />} /> 
          <Route path="/client/register" element={isAuthenticated ? <Navigate to="/client/profile" /> : <ClientRegister />} />   
          <Route path="/client/home" element={isAuthenticated ? <ClientHome /> : <Navigate to="/client/login" />} /> 
          <Route path="/client/profile" element={isAuthenticated ? <ClientProfile /> : <Navigate to="/client/login" />} />
          <Route path="/client/contact-us" element={isAuthenticated ? <ClientContactUs /> : <Navigate to="/client/login" />} />
          <Route path="/client/market-feedback" element={isAuthenticated ? <ClientMarketFeedback /> : <Navigate to="/client/login" />} />
          <Route path="/client/video" element={isAuthenticated ? <ClientVideo /> : <Navigate to="/client/login" />} />
          <Route path="/client/help" element={isAuthenticated ? <ClientHelp /> : <Navigate to="/client/login" />} />    
          <Route path="/client/listing" element={isAuthenticated ? <ClientListing /> : <Navigate to="/client/login" />} />    
          <Route path="/client/listing/create" element={isAuthenticated ? <ClientListingCreate /> : <Navigate to="/client/login" />} />    
          <Route path="/client/listing/payment-status/:status" element={<ClientListingPaymentStatus />} />    
          <Route path="/client/listing/:id/image" element={isAuthenticated ? <ClientListingImage /> : <Navigate to="/client/login" />} />    
          <Route path="/client/listing/:id/update" element={isAuthenticated ? <ClientListingUpdate /> : <Navigate to="/client/login" />} />    
          <Route path="/client/listing-enquiry" element={isAuthenticated ? <ClientListingEnquiry /> : <Navigate to="/client/login" />} />    
          <Route path="/client/ads" element={isAuthenticated ? <ClientAds /> : <Navigate to="/client/login" />} /> 
          <Route path="/client/ads/create" element={isAuthenticated ? <ClientAdsCreate /> : <Navigate to="/client/login" />} />   
          <Route path="/client/ads/payment-status/:status" element={<ClientAdsPaymentStatus />} /> 
          <Route path="/client/ads/:id/upgrade" element={isAuthenticated ? <ClientAdsUpgrade /> : <Navigate to="/client/login" />} />       
          <Route path="/client/payment" element={isAuthenticated ? <ClientPayment /> : <Navigate to="/client/login" />} /> 
          <Route path="/client/video-post" element={isAuthenticated ? <ClientVideoPost /> : <Navigate to="/client/login" />} />  
          <Route path="/agent/login" element={isAuthenticated ? <Navigate to="/agent/home" /> : <AgentLogin />} />
          <Route path="/agent/forgot-password" element={isAuthenticated ? <Navigate to="/agent/profile" /> : <AgentForgotPassword />} /> 
          <Route path="/agent/register" element={isAuthenticated ? <Navigate to="/agent/profile" /> : <AgentRegister />} />   
          <Route path="/agent/home" element={isAuthenticated ? <AgentHome /> : <Navigate to="/agent/login" />} /> 
          <Route path="/agent/profile" element={isAuthenticated ? <AgentProfile /> : <Navigate to="/agent/login" />} />
          <Route path="/agent/bank-account" element={isAuthenticated ? <AgentBankAccount /> : <Navigate to="/agent/login" />} />
          <Route path="/agent/wallet" element={isAuthenticated ? <AgentWallet /> : <Navigate to="/agent/login" />} />  
          <Route path="/agent/contact-us" element={isAuthenticated ? <AgentContactUs /> : <Navigate to="/agent/login" />} /> 
          <Route path="/agent/video" element={isAuthenticated ? <AgentVideo /> : <Navigate to="/agent/login" />} />
          <Route path="/agent/help" element={isAuthenticated ? <AgentHelp /> : <Navigate to="/agent/login" />} />
          <Route path="/agent/client" element={isAuthenticated ? <AgentClient /> : <Navigate to="/agent/login" />} />  
          <Route path="/agent/user" element={isAuthenticated ? <AgentUser /> : <Navigate to="/agent/login" />} />     
          <Route path="/agent/business" element={isAuthenticated ? <AgentBusiness /> : <Navigate to="/agent/login" />} />
          <Route path="/agent/payout" element={isAuthenticated ? <AgentPayout /> : <Navigate to="/agent/login" />} />     
          <Route path="/agent/payment-status/:status" element={<AgentPaymentStatus />} />   
          <Route path="/agent/payment" element={isAuthenticated ? <AgentPayment /> : <Navigate to="/agent/login" />} />  
          <Route path="/agent/video-post" element={isAuthenticated ? <AgentVideoPost /> : <Navigate to="/agent/login" />} /> 
        </Route>   
        <Route path="/client/invoice/:page/:id" element={<ClientInvoice />} />   
        <Route path="/agent/invoice/:id" element={<AgentInvoice />} />     
        <Route path="/agent/id-card" element={<AgentIDCard />} />          
      </Routes>                 
    </BrowserRouter>      
  ); 
}

export default App; 